<template>
  <div style="height: 100%">
    <div id="echarts-box" style="height: 300px"></div>
    <el-row :gutter="20" style="padding-top:100px">
      <el-col :span="24">
        <el-row :gutter="20" style="padding-bottom:20px">
          <el-col :xs="24" :sm="8" :xl="8">
            <div class="dashboard-item">
              <div class="dashboard-item-top">
                <i style="background-color:#42BC9B;">
                  <i class="iconfont icon-qiyexinxi"></i>
                </i>
                <div>
                  <h2>{{qrcodeNum1}}</h2>
                  <span>溯源码总数</span>
                </div>
              </div>
              <div class="dashboard-item-bottom">
                <h3>已打印<span class="text-color-green">{{qrcodeNum2}}</span></h3>
                <h3>未打印<span class="text-color-red">{{qrcodeNum3}}</span></h3>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="8" :xl="8">
            <div class="dashboard-item">
              <div class="dashboard-item-top" style="border:none">
                <i style="background-color:#51a3ff;">
                  <i class="iconfont icon-jigouguanli"></i>
                </i>
                <div>
                  <h2>{{orderCount}}</h2>
                  <span>订单总量</span>
                </div>
              </div>
              <div class="dashboard-item-bottom">
                <!-- <h3>正常<span class="text-color-green">{{govNum}}</span></h3>
                <h3>异常<span class="text-color-red">0</span></h3> -->
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="8" :xl="8">
            <div class="dashboard-item">
              <div class="dashboard-item-top" style="border:none">
                <i style="background-color:#6633cc;">
                  <i class="iconfont icon-yonghu" style="font-size:28px"></i>
                </i>
                <div>
                  <h2>{{userNum}}</h2>
                  <span>平台用户数</span>
                </div>
              </div>
              <div class="dashboard-item-bottom">
                <!-- <h3>政府<span class="text-color-green">11</span></h3>
                <h3>企业<span class="text-color-blue">98</span></h3> -->
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="8" :xl="8">
            <div class="dashboard-item">
              <div class="dashboard-item-top">
                <i style="background-color:#3b78e7;">
                  <i class="iconfont icon-chanpin" style="font-size:32px"></i>
                </i>
                <div>
                  <h2>{{productNum1}}</h2>
                  <span>产品总数</span>
                </div>
              </div>
              <div class="dashboard-item-bottom">
                <h3>在产中<span class="text-color-green">{{productNum2}}</span></h3>
                <h3>已停产<span class="text-color-blue">{{productNum3}}</span></h3>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="8" :xl="8">
            <div class="dashboard-item">
              <div class="dashboard-item-top" style="border:none">
                <i style="background-color:#33cc66;">
                  <i class="iconfont icon-pici" style="font-size:46px"></i>
                </i>
                <div>
                  <h2>{{batchNum}}</h2>
                  <span>批次总数</span>
                </div>
              </div>
              <div class="dashboard-item-bottom">
                <!-- <h3>虚拟机规格<span class="text-color-green">11</span></h3>
                <h3>容器规格<span class="text-color-blue">1</span></h3> -->
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="8" :xl="8">
            <el-row :gutter="20">
              <el-col :span="12">
                <router-link to="ContentsManagement">
                  <div class="dashboard-item">
                    <div class="dashboard-item-mini">
                      <i style="background-color:#f39c12;">
                        <i class="iconfont icon-gonggao"></i>
                      </i>
                      <p>通知公告<br>规章制度</p>
                    </div>
                  </div>
                </router-link>
              </el-col>
              <el-col :span="12">
                <router-link to="user">
                  <div class="dashboard-item">
                    <div class="dashboard-item-mini">
                      <i style="background-color:#ff6600;">
                        <i class="iconfont icon-zuzhiguanli"></i>
                      </i>
                      <p>组织机构<br>角色用户</p>
                    </div>
                  </div>
                </router-link>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
      <!-- <el-col :span="12">
        <div class="dashboard-item">
          <div class="block">
            <el-carousel>
              <el-carousel-item v-for="item in 5" :key="item">
                <img width="100%" :src="require(`@/assets/images/dashboard/${item}.jpg`)">
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </el-col> -->
    </el-row>
  </div>
</template>

<script>
import echarts from 'echarts'
import { getBatchNum, getQrcodeNum, getMerchantReport, getOrderReport, getProductNum, getUserNum } from '@/api/orgdashboard'
export default {
  data() {
    return {
      option: {
        title: {
          text: '订单报表'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['订单量']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: 'value'
        },
        series: {
          name: '订单量',
          type: 'line',
          stack: '总量',
          data: []
        }
      },
      batchNum: '',
      govNum: '',
      orgNum: '',
      userNum: '',
      productNum1: '',
      productNum2: '',
      productNum3: '',
      month: [],
      qrcodeNum1: '',
      qrcodeNum2: '',
      qrcodeNum3: '',
      orderCount: 0
    }
  },
  methods: {
    getDashboardData() {
      getBatchNum().then(res => {
        if (res.status === 1) {
          this.batchNum = res.data
        }
      })
      getMerchantReport().then(res => {
        if (res.status === 1) {
          console.log(res)
        }
      })
      getOrderReport().then(res => {
        if (res.status === 1) {
          const resultMonth = res.data.map(_ => _.month)
          const resultNum = res.data.map(_ => _.num)
          this.orderCount = resultNum.reduce((prev, curr, idx, arr) => {
            return prev + curr
          })
          this.option.xAxis.data = resultMonth
          this.option.series.data = resultNum
          console.log(this.option.series.data)
          const echartsBox = document.getElementById('echarts-box')
          const myChart = echarts.init(echartsBox)
          myChart.setOption(this.option, true)
        }
      })
      getProductNum().then(res => {
        if (res.status === 1) {
          this.productNum1 = res.data.num1
          this.productNum2 = res.data.num2
          this.productNum3 = res.data.num3
        }
      })
      getQrcodeNum().then(res => {
        if (res.status === 1) {
          this.qrcodeNum1 = res.data.num1
          this.qrcodeNum2 = res.data.num2
          this.qrcodeNum3 = res.data.num3
        }
      })
      getUserNum().then(res => {
        if (res.status === 1) {
          this.userNum = res.data
        }
      })
    }
  },
  mounted() {
    this.getDashboardData()
  }
}
</script>

<style lang="scss" scoped>
.dashboard-item {
  border: solid 1px #e5e5e5;
  border-radius: 5px;
  box-shadow: #e5e5e5 2px 2px 10px;
  padding: 30px 15px 15px;
  color: #666;
  margin-bottom: 20px;
  min-height: 141px;
  .dashboard-item-top {
    border-bottom: solid 1px #e5e5e5;
    padding-bottom: 15px;
    div {
      display: inline-block;
      vertical-align: middle;
      h2 {
        font-size: 28px;
        font-weight: bold;
        padding-bottom: 5px;
      }
    }
    i {
      vertical-align: middle;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      text-align: center;
      line-height: 50px;
      display: inline-block;
      margin-right: 15px;
      &.iconfont {
        font-size: 36px;
        color: #fff;
      }
    }
  }
  .dashboard-item-mini {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: -5px;
    i {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      text-align: center;
      line-height: 50px;
      &.iconfont {
        font-size: 36px;
        color: #fff;
      }
    }
    p {
      font-size: 14px;
      padding-top: 5px;
      line-height: 22px;
    }
  }
  .dashboard-item-bottom {
    padding-top: 10px;
    display: flex;
    h3 {
      width: 50%;
      text-align: center;
      font-size: 12px;
      span {
        font-size: 18px;
        padding-left: 10px;
      }
      &:nth-child(1){
        border-right: solid 2px #e5e5e5;
      }
    }
  }
}
</style>
